<template>
  <div
    v-loading="tableLoading"
    class="applyfor"
  >
    <sw-table
      ref="applyTable"
      :page-sizes="[10,15,20]"
      :total-count="tableCount"
      :page-size="pageSize"
      :show-selection="false"
      :table-name="'apply-table'"
      :table-title="tableTitle"
      :table-data="tableData"
      :table-operation="tableOperation"
      :conflict-operation="conflictOperation"
      :has-add-button="false"
      style="background: #fff"
      @operation-handle="handleOperation"
      @size-change="changeSize"
      @change-page="changePage"
      @next-page="changePage"
      @prev-page="changePage"
    />
    <sw-dialog
      :title="'流程图'"
      :visible.sync="dialogIframeVisible"
      :destroy-on-close="true"
      top="50px"
      width="80vw"
    >
      <iframe
        :src="iframeSrc"
        style="border: none; width:  100%; height: calc(100vh - 145px)"
      />
    </sw-dialog>
    <sw-dialog
      :visible.sync="urgentDialogVisible"
      :destroy-on-close="true"
      title="催办"
    >
      <el-form
        ref="urgentForm"
        :model="urgentForm"
      >
        <el-form-item label="应用名称">
          <el-input
            :disabled="true"
            v-model="urgentForm.act_form_name"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item label="任务环节">
          <el-input
            :disabled="true"
            v-model="urgentForm.taskName"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          :rules="[
            { required: true, message: '请输入催办消息', trigger: 'blur' }
          ]"
          label="催办消息"
          prop="massage"
        >
          <el-input
            v-model="urgentForm.massage"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <sw-button @click="urgentDialogVisible = false">取 消</sw-button>
        <sw-button
          type="primary"
          @click="postUrgentTask"
        >确 定</sw-button>
      </span>
    </sw-dialog>
  </div>
</template>
<script>
import service, { designFormUrl } from '@/utils/service'
import { parseTime } from '@/utils/index.js'
import '../css/worklist/applyfor.scss'
export default {
  data () {
    return {
      imgSrc: '', // 流程图
      tableLoading: false,
      expandColumns: [],
      urgentForm: {
        act_form_name: '',
        taskName: '',
        massage: ''
      },
      urgentTempRow: '',
      urgentDialogVisible: false,
      dialogIframeVisible: false,
      iframeSrc: '',
      currentPage: 1,
      pageSize: 10,
      tableCount: 0,
      tableData: [
      ],
      tableTitle: [
        { prop: 'serialNumber', label: '流水号', width: '120', sortable: true },
        { prop: 'swResource', label: '事务来源', width: '120', sortable: true },
        { prop: 'swName', label: '事务名称', width: '120', sortable: true },
        { prop: 'taskName', label: '当前节点', width: '120', sortable: true },
        { prop: 'create_time', label: '发起时间', width: '120', sortable: true },
        { prop: 'spendTime', label: '已耗时', width: '120', sortable: true },
        { prop: 'nodeTime', label: '当前节点已耗时', width: '120', sortable: true }
      ],
      tableOperation: [
        { name: '查看', icon: 'su-icon-details', operation: 'process' },
        { name: '催办', icon: 'su-icon-cuiban', operation: 'urgent' },
        { name: '修改', icon: 'su-icon-edit', operation: 'edit' },
        { name: '撤回', icon: 'su-icon-circle-minus', operation: 'revoke' }
      ],
      conflictOperation: {
        edit: { prop: 'edit', value: [false] },
        urgent: { prop: 'canUrge', value: [false] },
        revoke: { prop: 'canRecall', value: [false] },
        process: { prop: 'taskId', value: [''] }
      }
    }
  },
  computed: {
    pageVisible () {
      return this.$store.state.appflow.pageVisible
    }
  },
  watch: {
    pageVisible (val) {
      if (val) {
        this.getData()
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    handleWarningRow (approval) {
      if (approval.status === 'reject') {
        return true
      } else {
        return false
      }
    },
    getData () {
      this.tableLoading = true
      this.expandColumns = []
      service.get('/v1/application/queryMyApply', {
        params: {
          page: this.currentPage,
          limit: this.pageSize
        }
      }).then(res => {
        this.tableLoading = false
        this.tableData = res.data.map((item, index) => {
          if (item.operation === 'SAVE' || item.operation === 'RECALL') {
            item.edit = true
          } else {
            item.edit = false
          }
          item.id = index
          item.create_time = parseTime(item.create_time)
          if (item.detail) {
            item.detail.reverse()
            item.detail = item.detail.map(d => {
              let status = '未审核'
              if (d.deleteReason) {
                switch (d.deleteReason) {
                  case 'completed':
                    status = '已审核'
                    break
                  case 'reject':
                    status = '被驳回'
                    break
                  case 'delegate':
                    status = '已代理'
                    break
                  default:
                    status = '未通过'
                }
              }
              return { name: d.name, assignee: d.assigneeName, endTime: parseTime(d.endTime), comment: d.comment, status: status }
            })
          }

          return item
        })
        this.tableCount = res.count
      }).catch(error => {
        this.$swMessage.error(error)
      })
    },
    handleOperation (id, operation) {
      switch (operation) {
        case 'edit':
          this.editTask(id)
          break
        case 'urgent':
          this.urgentTask(id)
          break
        case 'revoke':
          this.revokeTask(id)
          break
        case 'process':
          this.openApplyforDialog(id)
          break
        case 'detail':
          this.handleToggleExpand(id)

          break
      }
    },
    handleToggleExpand (id) {
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      if (this.expandColumns.includes(tempRow.id)) {
        this.expandColumns.splice(this.expandColumns.indexOf(tempRow.id), 1)
        this.$refs.applyTable.tableMethod('toggleRowExpansion', tempRow, false)
      } else {
        this.expandColumns.push(tempRow.id)
        this.$refs.applyTable.tableMethod('toggleRowExpansion', tempRow, true)
      }
    },
    editTask (id) {
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      window.open(`${designFormUrl}/handle?fid=${tempRow.act_form_id}&from=adminplatform&ffid=${tempRow.ff_instance_id}&taskid=${tempRow.taskId}&processInstanceId=${tempRow.act_process_id}&token=${localStorage.getItem('Admin-Token')}`, '_blank')
    },
    urgentTask (id) {
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      this.urgentTempRow = tempRow
      this.urgentForm.act_form_name = tempRow.act_form_name
      this.urgentForm.taskName = tempRow.taskName
      this.urgentDialogVisible = true
    },
    postUrgentTask () {
      this.$refs['urgentForm'].validate((valid) => {
        if (valid) {
          service.post('/v1/process/urgentTask', {
            taskId: this.urgentTempRow.taskId,
            massage: this.urgentForm.massage
          })
            .then((res) => {
              this.getData()
              this.urgentDialogVisible = false
            }).catch(error => {
              this.$swMessage.error(error)
            })
        } else {
          return false
        }
      })
    },
    revokeTask (id) {
      service.post('/v1/process/reCall', {
        taskId: this.tableData[id].taskId
      })
        .then((res) => {
          this.getData()
        }).catch(error => {
          this.$swMessage.error(error)
        })
    },
    openApplyforDialog (id) {
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      window.open(`${designFormUrl}/looking?fid=${tempRow.act_form_id}&from=adminplatform&ffid=${tempRow.ff_instance_id}&taskid=${tempRow.taskId}&processInstanceId=${tempRow.act_process_id}&token=${localStorage.getItem('Admin-Token')}`, '_blank')
    },
    getShinePic (tempRow) {
      service.get('/leave/getShineProcImage', {
        params: {
          processInstanceId: tempRow.act_process_id
        }
      }).then((res) => {
        this.imgSrc = 'data:image/png;base64,' + res.images[0]
        this.dialogIframeVisible = true
      })
    },
    changeSize (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getData()
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
    }
  }
}
</script>
